import React from 'react'
import PropTypes from 'prop-types'
import style from './index.module.css'

const ErrorMessage = ({ message }) => (
  <div className='container'>
    <p className={ style.message }>{message}</p>
  </div>
)

export default ErrorMessage

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
}
